import Service from "../../Service";
import Axios from "../../Config/API";
import { IListarBancos } from "../../../Interfaces/Geral/ListarBancosInterface/ListarBancosInterface";

export async function ListarBancosService() {
    return Service(
        Axios.get<Array<IListarBancos>>(`/home/bancos/listarbancos`)
    );
}
